
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"30","height":"22","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.469 10.217c0-5.19 4.215-9.399 9.414-9.399h1.011c5.2 0 9.414 4.208 9.414 9.399v1.558c0 5.19-4.215 9.398-9.414 9.398h-1.011c-5.2 0-9.414-4.208-9.414-9.398v-1.558z","fill":"url(#paint0_linear_6364_7859)"}}),_c('path',{attrs:{"d":"M24.223 10.777a.26.26 0 010 .438l-8.062 5.2a.261.261 0 01-.403-.22V5.797c0-.207.23-.332.403-.22l8.062 5.2z","fill":"#fff"}}),_c('path',{attrs:{"d":"M12.208 8.636H5.183a.261.261 0 00-.261.26v.069c0 .144.117.26.261.26h7.025a.261.261 0 00.261-.26v-.068a.261.261 0 00-.261-.261z","fill":"#7B01B5"}}),_c('path',{attrs:{"d":"M8.003 11.31H.978a.261.261 0 00-.261.26v.069c0 .144.117.26.261.26h7.025a.261.261 0 00.261-.26v-.068a.261.261 0 00-.261-.261z","fill":"#E27CFC"}}),_c('path',{attrs:{"d":"M12.208 13.982H5.183a.261.261 0 00-.261.261v.068c0 .145.117.261.261.261h7.025a.261.261 0 00.261-.26v-.069a.261.261 0 00-.261-.26z","fill":"#7B01B5"}}),_c('defs',[_c('linearGradient',{attrs:{"id":"paint0_linear_6364_7859","x1":"29.308","y1":"10.996","x2":"9.469","y2":"10.996","gradientUnits":"userSpaceOnUse"}},[_c('stop',{attrs:{"stop-color":"#7B01B5"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#E27CFC"}})])])])
          )
        }
      }
    